import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Paper, Button, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { FormTextField, FormError } from '../../../components/Form';
import { loginUser } from '../../../actions';
import {
  minLength,
  maxLength,
  required,
  validateEmail
} from '../../../utils/validators';

const StyledLink = styled(Link)`
  text-decoration: none;
  span {
    text-transform: none;
    font-size: 12px;
    color: #005a96;
  }
`;

const StyledLinkWrapper = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
`;

const StyledPaper = styled(Paper)`
  padding: 20px;
  max-width: 400px;
  width: 100%;
  margin: 15px auto;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const StyledButton = styled(Button)`
  && {
    margin-top: 20px;
    margin-bottom: 10px;
  }
`;

const emailFieldValidation = [required, validateEmail];

const passwordFieldValidation = [required, minLength(6), maxLength(25)];

const loginForm = ({ handleSubmit, error, signInUser }) => (
  <div className="pageWrapper">
    <StyledPaper>
      <StyledForm onSubmit={handleSubmit(signInUser)}>
        <Typography gutterBottom variant="headline">
          Login
        </Typography>
        <Field
          name="email"
          label="Email"
          type="email"
          fullWidth
          component={FormTextField}
          validate={emailFieldValidation}
        />
        <Field
          name="password"
          label="Password"
          type="password"
          fullWidth
          component={FormTextField}
          validate={passwordFieldValidation}
        />
        <StyledLinkWrapper>
          <StyledLink to="/forgot-password">
            <Typography component="span">Forgot Password?</Typography>
          </StyledLink>
        </StyledLinkWrapper>
        <StyledButton variant="raised" color="primary" type="submit" fullWidth>
          Login
        </StyledButton>
        {error && <FormError msg={error.replace('. ', '. \n')} style={{whiteSpace: 'pre'}} />}
      </StyledForm>
    </StyledPaper>
  </div>
);

const mapDispatchToProps = dispatch => ({
  signInUser: body => dispatch(loginUser(body).request)
});

const connectedForm = connect(
  null,
  mapDispatchToProps
)(loginForm);

export default reduxForm({
  form: 'loginForm'
})(connectedForm);
